import React, { useState } from "react";

const RegisterUserForm = () => {
  const [uid, setUid] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setMessage(""); // Reset any previous message

    try {
      const response = await fetch(
        // "https://us-central1-ecb-pms.cloudfunctions.net/registerUser"
        "https://us-central1-ecbdevelopment-9eafc.cloudfunctions.net/registerUser"
        // "https://registeruser-p2xodpgboa-uc.a.run.app"
         ,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid,
            email,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message); // Success message
      } else {
        setMessage(data.message || "Failed to register user");
      }
    } catch (error: unknown) {
      const err = error as Error;
      setMessage("Error: " + err.message);
    } finally {
      setLoading(false); // Stop the loading state
    }
  };

  return (
    <div>
      <h2>Register User</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="uid">UID:</label>
          <input
            type="text"
            id="uid"
            value={uid}
            onChange={(e) => setUid(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Registering..." : "Register User"}
        </button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default RegisterUserForm;
